import { BaseRequest, IBaseRequest } from '../../BaseRequest';
import { Filter, toFilterXml } from '../../dataObjects/Filter';
import { Order, toOrderXml } from '../../dataObjects/Order';

export interface IListMessageTemplateRequest extends IBaseRequest {
    offset?:       string;
    limit?:        string;
    treeHandle?:   string;
    draftsOnly?:   string;
    templateName?: string;
    onlyDefault?:  string;
    language?:     string;
    ORDER?:        Order;
    FILTER?:       Filter;
}

export class ListMessageTemplateRequest extends BaseRequest implements IListMessageTemplateRequest {
    public offset?:       string;
    public limit?:        string;
    public treeHandle?:   string;
    public draftsOnly?:   string;
    public templateName?: string;
    public onlyDefault?:  string;
    public language?:     string;
    public ORDER?:        Order;
    public FILTER?:       Filter;

    constructor(server: string, session: string, otherOptions: any) {
        super(server, session);
        this.offset = otherOptions.offset;
        this.limit = otherOptions.limit;
        this.treeHandle = otherOptions.treeHandle;
        this.draftsOnly = otherOptions.draftsOnly;
        this.templateName = otherOptions.templateName;
        this.onlyDefault = otherOptions.onlyDefault;
        this.language = otherOptions.language;
        this.ORDER = otherOptions.ORDER;
        this.FILTER = otherOptions.FILTER;
    }

    public toXml(): string {
        var parameters: string = super.toXml();

        parameters += this.makeNode(this.offset, 'offset');
        parameters += this.makeNode(this.limit, 'limit');
        parameters += this.makeNode(this.treeHandle, 'treeHandle');
        parameters += this.makeNode(this.draftsOnly, 'draftsOnly');
        parameters += this.makeNode(this.templateName, 'templateName');
        parameters += this.makeNode(this.onlyDefault, 'onlyDefault');
        parameters += this.makeNode(this.language, 'language');
        if (this.ORDER) parameters += toOrderXml(this.ORDER);
        if (this.FILTER) parameters += toFilterXml(this.FILTER);
        
        return super.wrapperXml('ListMessageTemplate', parameters);
    }
}
